export default __webpack_public_path__ + "static/media/logo.fb78c3f2.svg";